export default class DOMGL_OBJ {

	constructor( prop = {}, color ) {

		//
		this.prop = prop;

		//
		this.width = Number( prop.w );
		this.height = Number( prop.h );
		this.name = prop.name;
		this.type = prop.type;
		this.mediaType = prop.mediaType;
		this.key = prop.key;
		this.postId = prop.postId;
		this.gl = null;
		this.wrap = prop;
		this.color = color ? color : 'black';

		//
		this.videoHls = null;
		this.videoElement = null;
		// this.videoSrc = getVideoSrc( prop.mp4Hd, prop.mp4Fhd, prop.mp4Hd );
		this.videoSrc = getVideoSrc( prop.mp4Hd, prop.mp4Fhd, prop.mp4Hd );
		// if( DETECT.device.any ){
		// 	this.videoSrc = prop.hls;
		// }

		//
		if( this.mediaType === 'video' && this.videoSrc ){
			this.videoElement = document.createElement('video');

			// //
			// if( this.name === 'home' ){
			// 	this.videoElement.currentTime = 10;
			// 	this.videoElement.play();
			// }

			this.videoElement.preload = "none";
			this.videoElement.muted   = true;
			this.videoElement.loop    = true;
			this.videoElement.setAttribute('crossorigin', 'anonymous');
			this.videoElement.setAttribute('muted', '');
			this.videoElement.setAttribute('playsinline', 'playsinline');
			this.videoElement.src = this.videoSrc;

			// if( DETECT.device.any ){
			// 	if( Hls.isSupported() ) {
			// 		this.videoHls = new Hls();
			// 		this.videoHls.loadSource( this.videoSrc );
			// 		this.videoHls.attachMedia( this.videoElement );
			// 	} else {
			// 		this.videoElement.src = this.videoSrc;
			// 	}
			// } else {
			// 	this.videoElement.src = this.videoSrc;
			// }
		}

		//
		const thumbWqhd = prop.thumbWqhd;
		const thumbFhd  = prop.thumbFhd;
		const thumbHd   = prop.thumbHd;
		const thumbSd   = prop.thumbSd;
		// this.thumbSrc = getSrc( thumbHd, thumbFhd, thumbSd, thumbHd );
		this.thumbSrc = getSrc( thumbHd, thumbHd, thumbSd, thumbHd );
		this.thumbElement = new Image();

		//
		this.posterSrc = getSrc( prop.poster );
		this.posterElement = new Image();

		//
		this.video = {
			canplay : {
				flg : false,
				func : null,
			},
			playing : {
				flg : false,
				func : null,
			},
			// hls  : this.videoHls,
			el   : this.videoElement,
			src  : this.videoSrc
		}

		//
		this.poster = {
			isloading : false,
			isloaded  : false,
			el  : this.posterElement,
			src : this.posterSrc + '&id=' + this.postId
		}

		//
		this.thumb = {
			isloading : false,
			isloaded  : false,
			el  : this.thumbElement,
			src : this.thumbSrc + '&id=' + this.postId
		}

		//
		this.onInit();

	}

	onInit(){
		if( this.video.el ){
			// if( this.video.hls ){
			// 	this.video.hls.on( Hls.Events.MANIFEST_PARSED, () => {
			// 		this.video.canplay.flg = true;					
			// 	});
			// }
			this.video.canplay.func = () => {
				this.video.canplay.flg = true;
			}
			this.video.el.addEventListener('canplay', this.video.canplay.func );
			this.video.playing.func = () => {
				this.video.playing.flg = true;
			}
			this.video.el.addEventListener('playing', this.video.playing.func );
		}
	}

	onDestroy(){

		//
		this.poster.el = null;
		this.thumb.el = null;

		//
		if( this.video.el ){
			// if( this.video.hls ){
			// 	this.video.hls.removeAllListeners();
			// 	this.video.hls.detachMedia();
			// 	this.video.hls.destroy();
			// 	this.video.hls = null;
			// }
			if( this.video.canplay.func ){
				this.video.el.removeEventListener('canplay', this.video.canplay.func );
				this.video.canplay.func = null;
			}
			if( this.video.playing.func ){
				this.video.el.removeEventListener('playing', this.video.playing.func );
				this.video.playing.func = null;
			}
		}
	}

}









































